import slider1 from './img/slide-1.jpg';
import slider2 from './img/slide-2.jpg';
import slider3 from './img/slide-3.jpg';
export default [
	{
		title: 'Committed to changing lives',
		description:"We're on a mission to reconnect you to the beauty of sound",
		button: 'Read More',
		image: slider1,
		user: 'Nature Hearing Aid Service',
		userProfile: slider1,
	},
	{
		title: 'Better hearing is changing lives',
		description: "We're on a mission to reconnect you to the beauty of sound",
		button: 'Discover',
		image: slider2,
		user: 'Nature Hearing Aid Service',
		userProfile: slider2,
	},
	{
		title: 'You don’t have to live with hearing loss',
		description:"Contact Us",	 
		button: 'Buy now',
		image: slider3,
		user: 'Nature Hearing Aid Service',
		userProfile: slider3,
	} 
];